import React from "react";
import "./Supporters.css"
import supporters from "./images/supporters.png";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";

// 32 logos to import and display in container.
class Supporters extends React.Component {
    render() {
        return (
            <div>
                <NavBar/>
                <div id="supporter-page">
                    <h4>Our Supporters</h4>
                    <img id="supporter-display" src={supporters} alt="supporters"/>
                    <p id="logo-notice">
                        Notice: The logos, trademarks, and/or brand names that appear herein are for informational and/or non-profit purposes only. 
                        Any and all logos, trademarks, and/or brand names reproduced herein belong to their respective owners, and are not the property 
                        of Kids in Seats. Unless expressly stated otherwise herein, the reproduction by Kids in Seats of team logos, trademarks, or 
                        brand names is neither meant to convey a partnership, sponsorship, or other official affiliation between Kids in Seats and the 
                        respective owners of such logos, trademarks, or brand names, nor is such usage to be construed as an official endorsement of 
                        Kids in Seats by the respective owners of such logos, trademarks, or brand names.
                    </p>
                </div>
                <Footer/>
            </div>
            
        )
    }
}

export default Supporters;
